import { Component, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Material } from '../../../model/api/administration/material';
import { GenericDetail } from '../../generic/generic.detail';

@Component({
    selector: 'material-detail',
    templateUrl: 'material.detail.html'
})
export class MaterialDetail extends GenericDetail<Material, number> {

    @ViewChild('detailForm') detailForm: FormGroup;

    setItemDefaultValues() {
        this.item = new Material();
    }

    public resetForm() {
        this.detailForm.reset();
    }
}